import { gql } from '@apollo/client'

/* eslint graphql/template-strings: 0 */

export const AUTHENTICATE_USER_WITH_GOOGLE = gql`
  mutation authenticateUserWithGoogle($input: AuthenticateGoogleUserInput!) {
    googleAuth: authenticateUserWithGoogle(input: $input) {
      apiAccessToken {
        tokenString
        expiresAt
      }
      isNew
    }
  }
`
